/**
 * Custom smooth scroll function with easing
 * @param {number} targetPosition - The target Y position to scroll to
 * @param {number} duration - The duration of the scroll animation in milliseconds
 */
export const smoothScrollTo = (targetPosition, duration = 1000) => {
  const startPosition = window.scrollY;
  const distance = targetPosition - startPosition;
  let startTime = null;

  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);
    
    // Easing function - ease-in-out cubic
    const ease = t => t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1;
    
    window.scrollTo(0, startPosition + distance * ease(progress));
    
    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  }
  
  requestAnimationFrame(animation);
};

/**
 * Scrolls to an element with offset for sticky header
 * @param {React.RefObject} ref - The reference to the element to scroll to
 * @param {number} headerHeight - The height of the sticky header
 * @param {number} [additionalOffset=0] - Additional offset to add
 */
export const scrollToElement = (ref, headerHeight, additionalOffset = 0) => {
  if (ref.current) {
    const elementPosition = ref.current.getBoundingClientRect().top + window.scrollY;
    smoothScrollTo(elementPosition - headerHeight - additionalOffset);
  }
};

/**
 * Scrolls to a tab content when tab is clicked while in sticky mode
 * @param {React.RefObject} tabContentRef - Reference to the tab content
 * @param {React.RefObject} tabsRef - Reference to the tabs container
 * @param {number} headerHeight - Height of the sticky header
 */
export const scrollToTabContent = (tabContentRef, tabsRef, headerHeight) => {
  if (tabContentRef.current) {
    const tabHeight = tabsRef.current ? tabsRef.current.offsetHeight : 0;
    const yOffset = headerHeight + tabHeight;
    
    const tabContentTop = tabContentRef.current.getBoundingClientRect().top + window.scrollY;
    
    window.scrollTo({
      top: tabContentTop - yOffset - 12,
      behavior: 'smooth'
    });
  }
}; 